module.exports = __webpack_public_path__ + "static/media/cabo-de-controle.cfb4db0e.jpg";